module.exports = __webpack_public_path__ + "static/media/answerPIC12.a3f8f252.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPIC12.png
// module id = 1719
// module chunks = 0 1